import React from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const DeckBuilderHelpOverlay = ({ isOpen, onClose, onRestartTutorial }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="overlay" onClick={handleOverlayClick}>
      <div className="overlay-modal rules-overlay">
        <div className="overlay-header">
          <h2>{getUILoc('DECK_BUILDER_HELP.TITLE')}</h2>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {onRestartTutorial && (
              <button 
                className="tutorial-button" 
                onClick={() => {
                  onRestartTutorial();
                  onClose();
                }}
                style={{ fontSize: '0.7em', padding: '4px 10px' }}
              >
                {getUILoc('BUTTONS.TUTORIAL')}
              </button>
            )}
            <button className="close-button" onClick={onClose}>×</button>
          </div>
        </div>
        
        <div className="overlay-content">
          <pre className="rules-text">{getUILoc('DECK_BUILDER_HELP.BODY')}</pre>
        </div>
      </div>
    </div>
  );
};

export default DeckBuilderHelpOverlay;
